import { Icon } from "@iconify/react";
import StarRating from "../utils/StarRating";
import { useNavigate } from 'react-router-dom';

// Liste des IDs d'experts à afficher avec le badge "Nouveau!"
const NEW_EXPERTS_IDS = [
  '1b03c8b6-b532-4aab-8669-0050b7f6848f',
  '469d39d8-37d4-4565-8ac1-8429e08df353',
  '4e434aef-ae4d-4611-9e34-3b7f9e835889'
];

function ButtonStatus(props) {

    const { disponibily } = props;
    const { redirectProfil } = props;

    let button;

    switch(disponibily) {

        case "FREE":
            button = (
              <button className="modern-button primary" onClick={redirectProfil}>
                <Icon icon="ic:baseline-phone" className="icon" />
                Je consulte
              </button>
            );
            break;

        case "ON_WORK":
            button = (
              <button className="modern-button ghost consultation-disabled">
                <Icon icon="ic:baseline-phone-in-talk" className="icon" />
                En consultation
              </button>
            );
            break;

        default:
            button = (
              <button className="modern-button ghost" disabled>
                <Icon icon="ic:baseline-phone-disabled" className="icon" />
                Hors-Ligne
              </button>
            );
            break;
        
    }

  
    return (
      <>
        {button}
      </>
    );
  }

function BenefitsSupport(props) {

    let { benefits } = props;

    if(!benefits) {

        benefits = [];

    }
  
    return (
      <>
        {benefits.includes('CALL') ?  <Icon icon="mdi:telephone"/> : ""}
        {benefits.includes('CHAT') ?  <Icon icon="eva:message-circle-fill"/> : ""}
        {benefits.includes('MAIL') ?  <Icon icon="mdi:email"/> : ""}
        {/*<Icon icon="mdi:calendar" color={benefits.includes('MEET') ? '#3ea336' : '#FFF'} />*/}
      </>
    );
  }

function ExpertBox(props) {

    const navigate = useNavigate();

    let { benefits } = props;
    const isWebhook = props.isWebhook || window.location.pathname.includes('/webhook/');

    if(!benefits) {benefits = [];}

    const redirectProfil = () => {
        let profileUrl = props.profileUrl;
        if(profileUrl) {
            window.open(atob(profileUrl) + "?profileId=" + props.id, '_blank', 'noreferrer');
        } else if (isWebhook) {
            // Dans un contexte webhook/iframe, toujours ouvrir dans une nouvelle page
            const baseUrl = window.location.origin;
            window.open(baseUrl + "/" + props.officeName + "/client/expertList/" + props.id + "/", '_blank', 'noreferrer');
        } else {
            navigate("/" + props.officeName + "/client/expertList/" + props.id + "/");
        }
    };

    return (
        <div className="modern-card expert-card">
            <div className="expert-banner" style={{ 
                backgroundImage: `url("`+ props.imageBanner +`")` 
            }}>
                {NEW_EXPERTS_IDS.includes(props.id) && (
                    <div className="new-expert-badge">
                        <span className="badge-text">Nouveau!</span>
                        <span className="badge-pulse"></span>
                    </div>
                )}
                <div className="expert-avatar" onClick={redirectProfil} style={{ 
                    backgroundImage: `url("`+ props.imageProfile +`")` 
                }}></div>
            </div>
            
            <div className="card-body">
                <div className="expert-header">
                    <div className="expert-rating">
                        <div className="stars">
                            <StarRating advice={props.advice} />
                        </div>
                        <span className="consultation-count">{props.call} Consult.</span>
                    </div>
                    <div className="expert-benefits">
                        <BenefitsSupport benefits={props.benefits} />
                    </div>
                </div>
                
                <div className="expert-info">
                    <h3 className="expert-name">{props.name}</h3>
                    <div className="expert-category">{props.category}</div>
                    <p className="expert-description">{props.description}</p>
                </div>
                
                <div className="expert-features">
                    <div className="feature-item">
                        <Icon 
                          icon="mdi:calendar" 
                          className={`feature-icon ${benefits.includes('MEET') ? 'available' : 'unavailable'}`}
                        />
                        <span>RDV</span>
                    </div>
                </div>
            </div>
            
            <div className="card-footer">
                <ButtonStatus 
                  redirectProfil={redirectProfil}
                  disponibily={props.disponibily}
                />
            </div>
        </div>
    );
}

export default ExpertBox;